// @flow

import React from "react";
import SvgIcon, { type SvgIconProps } from "../SvgIcon";

const Plan = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <svg viewBox="0 0 12 12">
            <g>
                <rect x="1" y="3.75" width="9.99" height="1.75" />
                <rect x="1.01" y="9.25" width="9.99" height="1.75" />
                <polygon points="5.99 1 1 1 1 2.75 5.99 2.75 5.99 1 5.99 1" />
                <polygon points="11 6.5 6.01 6.5 6.01 8.25 11 8.25 11 6.5 11 6.5" />
            </g>
        </svg>
    </SvgIcon>
);

export default Plan;
